import { render } from "./PlainAdminRouteViewport.vue?vue&type=template&id=3e844b66"
import script from "./PlainAdminRouteViewport.vue?vue&type=script&lang=js"
export * from "./PlainAdminRouteViewport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__